import { createSelector } from '@reduxjs/toolkit'
import { BookingAvailability } from '@/store/bookingAvailabilitySlice'
import { cartSlice } from '@/store/cartSlice'
import { timeScheduleSlice } from '..'

export const selectedDaysSelector = createSelector(
  [
    timeScheduleSlice.selectors.service,
    cartSlice.selectors.selectedElementReservation,
    cartSlice.selectors.cartReservations,
    cartSlice.selectors.selectedBookingType,
  ],
  (
    service,
    selectedElementReservation,
    cartReservations,
    selectedBookingType
  ): number[] => {
    if (!service) {
      return []
    }

    const reservation =
      selectedBookingType === BookingAvailability.TICKETS
        ? cartReservations.find(
            (r) => r.spotName === null && r.spotType === null
          )
        : selectedElementReservation

    if (!reservation) {
      return []
    }

    const boughtService = reservation.boughtServices[service.serviceId]
    if (!boughtService) {
      // fallback to days of the daily schedule
      const keys = Object.keys(service.dailyTimeSchedules)
      return keys
        .map((key) => parseInt(key))
        .filter((time) => !Number.isNaN(time))
    }

    const days = Object.values(boughtService)
      .map((item) => item.days)
      .flat()

    return Array.from(new Set(days))
  }
)
